import { render, staticRenderFns } from "./FacturaTable.vue?vue&type=template&id=776e62de&scoped=true&"
import script from "./FacturaTable.vue?vue&type=script&lang=ts&"
export * from "./FacturaTable.vue?vue&type=script&lang=ts&"
import style0 from "./FacturaTable.vue?vue&type=style&index=0&id=776e62de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776e62de",
  null
  
)

export default component.exports